//Node Modules
import axios from 'axios'

//Types
import { FeatureFlag } from 'types/feature-flag';

const BASE_URL = '/features'

export function featureFlags(alias: string, version: string, locale: string, requestor: string | null):Promise<FeatureFlag[]> {
  return axios.get(`${BASE_URL}/${locale}/${alias}/${version}/getFeatureFlags${requestor ? '?requestorId='+requestor : ''}`).then(result => result.data).catch(err => undefined)
}